export default {
  title: 'Récompenses',
  guest: {
    eyebrow: 'Récompenses',
    headline: 'Chaque commande vous fait gagner des <highlight>récompenses</highlight>',
    subheading_one: 'Gagnez {{count}} point par {{amount}} dépensé.',
    subheading_other: 'Gagnez {{count}} points par {{amount}} dépensé.',
    cta: 'Inscrivez-vous & commencez à gagner',
    already_member: 'Déjà membre ?',
    sign_in: 'Se connecter',
    redeemable_heading: 'Vos points = nourriture gratuite',
    redeemable_eyebrow: '🎁 Récompenses à débloquer',
  },
  member: {
    balance_label: 'Votre solde',
    balance_suffix: 'points · valeur <highlight>{{amount}}</highlight>',
    next_reward: 'Prochaine récompense à <highlight>{{points}} pts</highlight>',
    redeem_hint: "✓ Vous pouvez utiliser jusqu'à {{points}} pts ({{amount}}) sur votre prochaine commande",
    expiration_zero: "⏳ {{points}} pts expirent aujourd'hui",
    expiration_one: '⏳ {{points}} pts expirent dans 1 jour',
    expiration_other: '⏳ {{points}} pts expirent dans {{count}} jours',
    pts_lifetime: 'Total pts',
    saved_lifetime: 'Total économisé',
    cta: 'Commander',
    redeemable_heading: 'Ce que vous pouvez utiliser',
    redeemable_eyebrow: 'Vous avez {{points}} pts ({{amount}})',
    redeemable_description:
      "Jusqu'à {{maxPoints}} pts ({{maxAmount}}) par commande. Les articles sous {{maxAmount}} sont entièrement gratuits.",
  },
  items: {
    free: 'GRATUIT',
    save: 'Économiser {{amount}}',
  },
  history: {
    eyebrow: 'Historique',
    title: 'Activité récente',
    load_more: 'Charger plus',
    sources: {
      welcome_bonus: 'Bonus de bienvenue',
      google_review_reward: 'Récompense avis Google',
      reward_loyalty_program_conversion: 'Conversion programme fidélité',
      cashback: 'Cashback gagné',
      refund: 'Commande remboursée',
      cashback_usage: 'Points utilisés',
      cashback_usage_refund: "Remboursement d'utilisation",
      expired_points_void: 'Points expirés',
      mobile_app_signup_bonus: "Bonus d'inscription app mobile",
    },
    detail_with_order: 'Commande #{{number}} · {{amount}}',
  },
  how_it_works: {
    eyebrow_guest: 'Simple & automatique',
    eyebrow_member: 'Rappel rapide',
    title: 'Comment ça marche',
    steps: {
      sign_up: {
        emoji: '📲',
        title: 'Inscription gratuite',
        desc: 'Créez un compte en 30 secondes.',
      },
      order: {
        emoji: '🍔',
        title: 'Commandez & gagnez',
        desc_one: '1 pt par {{amount}} — suivi automatique.',
        desc_other: '{{count}} pts par {{amount}} — suivi automatique.',
      },
      build: {
        emoji: '⭐',
        title: 'Cumulez des points',
        desc: 'Utilisable dès {{minPoints}} pts. Valide {{lifetime}} jours.',
      },
      save: {
        emoji: '🎁',
        title: 'Économisez au paiement',
        desc: "Jusqu'à {{maxAmount}} de remise — appliquée instantanément.",
      },
      repeat: {
        emoji: '🔄',
        title: 'Recommandez & économisez',
        desc: 'Chaque commande augmente votre solde.',
      },
    },
  },
  faq: {
    eyebrow: 'Questions ?',
    title: 'Questions fréquentes',
    items: {
      earn: {
        q: 'Comment gagner des points ?',
        a_one:
          'Vous gagnez 1 point pour chaque {{amount}} dépensé. Les points sont ajoutés automatiquement après chaque commande — sans scan ni code.',
        a_other:
          'Vous gagnez {{count}} points pour chaque {{amount}} dépensé. Les points sont ajoutés automatiquement après chaque commande — sans scan ni code.',
      },
      redeem: {
        q: 'Quand puis-je utiliser mes points ?',
        a: 'Vous pouvez utiliser vos points dès {{minPoints}} points atteints. Appliquez-les au paiement pour réduire votre total.',
      },
      max: {
        q: 'Combien puis-je économiser par commande ?',
        a: "Vous pouvez utiliser jusqu'à {{maxPoints}} points ({{maxAmount}}) par commande. C'est la remise maximale applicable en un seul paiement.",
      },
      validity: {
        q: 'Quelle est la durée de validité des points ?',
        a: 'Les points sont valides {{lifetime}} jours à compter de leur obtention. Utilisez-les avant expiration !',
      },
    },
  },
};
